import React, { useState,  useRef } from "react";

import "./contentpage.css";


import { Link } from "react-router-dom";
import LandingSection from "./LandingSection";
import Question from "../components/Question";
import FloatingPageNav from "../components/FloatingPageNav";
function IslamicTradePage6() {


  const contentRef = useRef(null);
const links = {
    prev: "/islamic-trade-page-5", 
    index: "/index",                 
    next: "/islamic-trade-page-7", 
  };
  const titleText = "Prohibition on Usury (Ribā)";


  const questions = [
    {
      text: "1. What is one of the primary reason Riba (usury/interest) is prohibited in Islam?",
      options: [
        {
          value: "A",
          label: "A. It discourages wealth accumulation.",
        },
        {
          value: "B",
          label: "B.  It is not compatible with modern banking",
        },
        {
          value: "C",
          label: "C. It creates unjust gain without shared risk.",
        },
        {
          value: "D",
          label: "D. It was only relevant in ancient trade practices.",
        },
      ],
      correct: "C",
    },
    {
      text: "2. According to Islamic teachings, what is the key difference between trade and Riba?",
      options: [
        { value: "A", label: "A. Trade is voluntary while Riba is forced" },
        {
          value: "B",
          label:
            "B. Trade involves mutual risk and consent, while Riba guarantees gain without risk",
        },
        {
          value: "C",
          label: "C. Trade happens only in cash, while Riba involves credits",
        },
        { value: "D", label: "D. Trade is taxed in Islam, but Riba is not." },
      ],
      correct: "B",
    },
    {
      text: "3. What is the significance of Surah Al-Baqarah 2:275 in relation to Riba?",
      options: [
        { value: "A", label: "A. It introduces the concept of zakat in Islam" },
        {
          value: "B",
          label:
            "B. It compares interest-based transactions with lawful trade and warns of grave consequences to those who consume Riba",
        },
        {
          value: "C",
          label: "C. It permits interest under certain conditions",
        },
        {
          value: "D",
          label: "D. It explains how to calculate interest rates fairly",
        },
      ],
      correct: "B",
    },
    {
      text: "4. Why is a Muslim obligated to follow the prohibition of Riba even if they do not understand the wisdom behind it?",
      options: [
        {
          value: "A",
          label:
            "A. Because the punishment for disobedience is always financial",
        },
        {
          value: "B",
          label: "B. Because Islamic law is flexible with economic matters",
        },
        {
          value: "C",
          label:
            "C. Because obedience to Allah and His Messenger is required, and understanding the wisdom behind it increase a believer in  faith",
        },
        {
          value: "D",
          label: "D. Because scholars have debated it for centuries",
        },
      ],
      correct: "C",
    },
  ];
  // State to track selected answers for all questions
  const [answers, setAnswers] = useState({});

  // Function to update an answer
  const handleAnswerChange = (questionIndex, selectedValue) => {
    setAnswers((prev) => ({ ...prev, [questionIndex]: selectedValue }));
  };

  // Compute score
  const score = questions.reduce((total, q, index) => {
    return total + (answers[index] === q.correct ? 1 : 0);
  }, 0);

  return (
    <div className="container">
    
      <LandingSection
        titleText={titleText}
        scrollToRef={contentRef}
        progressValue={6}
        timerMinutes={60}
        currentLevel={1}
      />

      <p className="content" ref={contentRef}>
        Welcome to <b>Day 6</b> of our journey into understanding Islamic
        Finanicial Jurisprudence. Today, we arrive at one of the most serious
        and foundational topics, which is the prohibition of Riba, often
        translated as usury or interest. This subject is not only central to
        Islamic jurisprudence but also deeply relevant in today’s globalized
        economy where interest-based transactions are the norm.
        <br />
        In this lesson, we will explore what Riba actually means, why it is
        forbidden, and how it differs from lawful trade. More than just a
        technical prohibition, we will uncover the spiritual, social, and
        economic wisdom behind this ruling. The Qur'an and Sunnah issue some of
        their most severe warnings on this topic, highlighting the gravity of
        engaging in interest-based practices. We will reflect on how modern
        justifications for Riba stand in contrast to timeless Islamic
        principles, and why trusting in divine guidance is essential even when
        worldly logic or pressures suggest otherwise. By the end of today’s
        session, we hope to not only understand the legal boundaries set by
        Islamic law but also to rekindle a sense of trust in Allah’s wisdom and
        a desire to pursue halal and ethical means of financial engagement,
        regardless of prevailing societal norms.
        <br />
        <br />
        <b>Introduction to Usury</b>
        <br />
        <br />
        Ribā is an Arabic term commonly translated as usury or interest. It is
        explicitly prohibited in Islam because it contradicts the principles of
        fairness, justice, and mutual benefit that underlie Islamic economic
        systems. Riba refers to an unjustified or exploitative gain in a
        financial transaction, particularly in loans or exchanges of similar
        commodities.
        <br />
        The term "Riba" literally means "increase" or "excess." <br />
        In Islamic finance, it refers to two primary types:
        <ul>
          <li> Usury of Surpluss (Riba al-Faḍl): The excess or surplus in barter
        exchanges of similar goods (e.g., trading unequal quantities of gold for
        gold).</li>
           <li> Usury of Deferment (Riba an-Nasī’ah): The gain derived from deferring a
        payment or charging interest on loans. </li>
        </ul>
       
       Both forms are prohibited because
        they exploit the weaker party and violate the principles of fairness and
        mutual consent. We will be understanding each type in more detail in the
        next lesson.
        <br />
        In today’s age of materialism and economic dependency, it is more
        important than ever to remind Muslims of the absolute prohibition of
        Riba (usury) in Islam. As modern financial systems become increasingly
        intertwined with interest-based models, many Muslims have unfortunately
        grown complacent, treating Riba as a necessity rather than a grave sin.
        This complacency has led to widespread justifications for engaging in
        usurious transactions, especially in Western societies where Muslims
        argue that sustaining a livelihood, acquiring education, or purchasing a
        home is impossible without resorting to interest-bearing loans. Yet,
        such arguments ignore the divine wisdom of Islamic teachings and reduce
        the comprehensive nature of Islam to a cultural preference rather than a
        complete way of life. <br />
        Allah’s words in the Qur’an are unequivocal:
        <br />
        "Those who consume interest will stand ˹on Judgment Day˺ like those
        driven to madness by Satan’s touch. That is because they say, “Trade is
        no different than interest.” But Allah has permitted trading and
        forbidden interest. Whoever refrains—after having received warning from
        their Lord—may keep their previous gains, and their case is left to
        Allah. As for those who persist, it is they who will be the residents of
        the Fire. They will be there forever. "
        <a href="https://quran.com/2/275" target="blank">
          (Surah Al Baqarah 2:275)
        </a>
        <br />
        These verses make it clear that no economic hardship can justify
        disobedience to Allah, especially when alternatives like interest-free
        systems and community support exist and can be developed further. Islam
        is not bound by time or geography; its divine rulings are applicable and
        functional in all eras and societies, including ours. Therefore, the
        idea that Riba is an unavoidable aspect of modern life directly
        contradicts the foundational belief that Islam is a complete and
        timeless system.
        <br />
        The severity of indulging in Riba is not merely a scholarly opinion or a
        matter of debate, rather it is grounded in the most serious warnings
        found in the Qur’an and the Sunnah.
        <br />
        Allah says:
        <br />
        "O believers! Fear Allah, and give up outstanding interest if you are
        ˹true˺ believers. If you do not, then beware of a war with Allah and His Messenger! But if you repent, you may retain your principal—neither inflicting nor suffering harm."
        <a href="https://quran.com/2/278" target="blank">
          (Surah Al Baqarah 2:278)
        </a>
        <br />
        This declaration is without parallel in Islamic law; there is no other
        sin that Allah warns against with the threat of war. This should shake
        the heart of any Muslim who believes in the unseen and fears standing
        before their Lord. It also encompasses every participant in a usurious
        transaction not just the receiver, but also the giver, the witness, and
        the one who records it, as found in the hadith:
        <br />
        The Messenger of Allah (peace be upon him) cursed the one who consumes
        Riba, the one who gives it, the one who writes it down, and the two who
        witness it. He said:
        <br />
        "They are all equal.”{" "}
        <a href="https://sunnah.com/muslim:1598" target="blank">
          (Sahih Muslim 1598)
        </a>
        <br />
        No amount of justification can erase these divine warnings. Muslims must
        wake up from the delusion that modernity nullifies divine injunctions.
        The spiritual repercussions of indulging in Riba hardness of heart, loss
        of barakah, and the wrath of Allah are more damaging than any financial
        hardship. We must revive the spirit of taqwa and rely on halal means,
        trusting that the One who forbade Riba has also provided lawful
        alternatives for the sincere.
        <br />
        <br />
        <b>Wisdom behind the prohibition of Riba</b>
        <br />
        <br />
        The wisdom behind the prohibition of Riba in Islam lies deeply in the
        core values of justice, fairness, and compassion. Islam establishes an
        economic framework that prioritizes equity and discourages exploitation,
        ensuring that transactions benefit all parties involved. Riba interest
        on loans is inherently unjust because it guarantees profit to the lender
        without bearing any risk, while the borrower shoulders all the burden,
        regardless of their outcome. This creates a structural imbalance where
        the rich become richer at the expense of the poor. Islam, in contrast,
        promotes fairness and mutual consent in trade, as stated in the Qur’an:
        <br />
        "O believers! Do not consume interest, multiplying it many times over.
        And be mindful of Allah, so you may prosper."{" "}
        <a href="https://quran.com/3/130" target="blank">
          (Surah Ali' Imran 3:130)
        </a>
        <br />
        The goal is to ensure that economic transactions are grounded in ethical
        behavior and mutual benefit. Riba is not just a monetary issue, rather
        it corrodes social relationships, promotes greed, and undermines
        compassion. By prohibiting it, Islam preserves the dignity of
        individuals and communities, ensuring that financial dealings do not
        become tools of oppression. In interest-based systems, the poor often
        fall into cycles of debt, where interest compounds relentlessly, turning
        a temporary hardship into a long-term trap. The Islamic system seeks to
        eliminate such exploitation, encouraging lending as a charitable and
        cooperative act rather than a profit-driven enterprise.
        <br />
        Moreover, the prohibition of Riba is a powerful mechanism for
        redirecting economic energy towards productive, real-world investment
        rather than financial speculation . Islam encourages partnerships based
        on profit and loss sharing, such as mudarabah and musharakah, where
        parties collaborate and share risk. This incentivizes careful business
        planning and promotes ventures that contribute to genuine economic
        development, not just financial gain.The Qur’an emphasizes the
        importance of trade:
        <br />
        “But Allah has permitted trading and forbidden interest”
        <a href="https://quran.com/2/275" target="blank">
          (Surah Al Baqarah 2:275)
        </a>{" "}
        <br />
        This reincforces that Islam is not against profit, but against
        guaranteed gain without risk. Riba-free systems also prevent the
        concentration of wealth in the hands of a few, a phenomenon that leads
        to social inequality and unrest. By fostering risk-sharing and equitable
        growth, Islam ensures that wealth circulates broadly within society,
        reaching the poor and vulnerable.When people share risks, they also
        share responsibilities and rewards, which strengthens communal ties and
        builds a more just economic order. In essence, the prohibition of Riba
        is not merely a financial ruling but a profound expression of Islamic
        ethics, shaping an economy rooted in trust, cooperation, and
        accountability.
        <br />
        The prohibition of Riba even though it is backed by wisdom and sound
        intellect, A Muslim is obligated to obey Allah and His Messenger
        unconditionally, whether or not the wisdom behind a command is fully
        understood. This obedience stems from submission and trust in the
        perfect knowledge and justice of the Creator. Allah says:
        <br />
        "It is not for a believing man or woman when Allah and His Messenger
        decree a matter to have any other choice in that matter. Indeed, whoever
        disobeys Allah and His Messenger has clearly gone ˹far˺ astray."
        <a href="https://quran.com/33/36" target="blank">
          (Surah Al-Ahzab, 33:36)
        </a>
        . <br />
        While understanding the wisdom behind divine laws is not a prerequisite
        for obedience, discovering such wisdom strengthens one’s certainty,
        deepens faith, and increases love for the rulings of Islam.
        <br />
        <br /> <br />
        <b>The Modern Fiat System - A Civilization Built Upon Riba</b>
        <br />
        <br />
        The modern global financial order is fundamentally a Riba-based system
        disguised under layers of economic jargon. Central banking, fiat
        currencies, and debt-driven economies are all built upon the principle
        of creating money from nothing and lending it at interest. When the gold
        standard was abolished in the 20th century, nations gained the ability
        to print money without any tangible backing. This new “fiat money”
        derives its value not from real assets but from governmental decree and
        public confidenc, which is a fragile and manipulable foundation.
        <br />
        At its core, fiat money is the modern face of Riba. Central banks lend
        newly created money to commercial banks with interest, and these banks
        in turn lend it to businesses and individuals, again with interest. This
        process ensures that the total amount of debt always exceeds the total
        amount of money in existence, making perpetual borrowing and inflation
        inevitable. As a result, people must constantly work harder just to
        maintain the same standard of living, while the wealthy who own assets
        that appreciate with inflation see their wealth multiply.
        <br />
        This system mirrors precisely what the Qur’an warned against:
        <br />
        “so that wealth does not circulate only among the rich among you.”
        <a href="https://quran.com/59/7" target="blank">
          (Surah Al-Hashr 59:7)
        </a>
        <br />
        Fiat money transfers wealth from the poor to the rich silently through
        inflation, taxation, and interest payments. It is a global machine of
        exploitation wrapped in financial sophistication.
        <br />
        Tragically, nearly every Muslim-majority nation today operates within
        this same system. Their central banks hold fiat reserves, their
        governments borrow from international lenders at interest, and their
        citizens are encouraged to take loans for consumption. From mortgages to
        student loans, Riba has become institutionalized at every level of
        economic life. Even “Islamic banks” often replicate the same profit
        mechanisms under new names, focusing more on appearance than on genuine
        compliance with Shariah.
        <br />
        This dependency on Riba-based systems is not only an economic issue,
        rather it is a moral and spiritual one. It demonstrates how far the
        Ummah has drifted from its divine guidance. The Prophet Muhammad (peace
        be upon him) prophesied:
        <br />
        “A time will come when there will remain no one who does not consume
        Riba, and if he does not consume it, its dust will reach him.”
        <a href="https://sunnah.com/abudawud:3331" target="blank">
          (Sunan Abu Dawood, 3331)
        </a>{" "}
        <br />
        We are living in that time. Every Muslim nation today is entangled in
        the dust of Riba, whether through national debt, fiat currencies, or
        interest-based trade. The result is widespread poverty, inequality, and
        dependence on non-Islamic financial powers. Economies based on Riba may
        appear strong on paper but are hollow at their core. They generate
        temporary booms followed by devastating collapses, as seen in every
        global financial crisis. Islam’s economic laws, in contrast, build
        stability through real assets, fair trade, and honest labor.
        <br />
        <br />
        <b>The Signs of the End Times and the Path to Renewal</b>
        <br />
        <br />
        The prevalence of Riba in today’s world is not only a tragedy, it is
        also a prophecy fulfilled. The Prophet Muhammad (peace be upon him)
        foretold that before the Last Day, Riba would become so widespread that
        no one would escape its influence. This prediction has become our
        reality. The near-total domination of Riba-based economies, even in
        Muslim lands, signals how deeply modern society has deviated from divine
        principles.
        <br />
        The signs of this deviation are visible in every corner of life:
        collapsing family values, widening gaps between rich and poor,
        corruption in governments, and spiritual emptiness in individuals. When
        an economy is built on Riba, it drains barakah from the entire society.
        People work tirelessly yet find no contentment. Nations earn billions
        yet struggle with debt. The Qur’an describes this perfectly:
        <br />
        “Allah destroys Riba and gives increase for charities.”
        <a href="https://quran.com/2/276" target="blank">
          (Surah Al-Baqarah, 2:276)
        </a>{" "}
        <br />
        The word “destroys” here (yamhaqu) signifies not only financial loss but
        the removal of blessing and peace. This explains why societies drenched
        in Riba experience constant crises, economic, moral, and psychological
        despite material progress. Their wealth grows outwardly but decays
        inwardly.
        <br />
        Yet, amid this darkness, hope remains. The solution lies in returning to
        the divine model of justice: a Riba-free economy rooted in real trade,
        risk-sharing, and ethical investment. Muslims must rediscover the
        prophetic way of conducting business, which is transparent, productive,
        and grounded in service to the community. The rise of digital and
        decentralized currencies like Bitcoin has renewed discussions on sound
        money that resists manipulation and inflation. Such technologies can
        offer tools for Muslims to rebuild economic independence but only if
        guided by Shariah principles and ethical intent.
        <br />
        Yet, amid this darkness, hope remains. The solution lies in returning to
        the divine model of justice: a Riba-free economy rooted in real trade,
        risk-sharing, and ethical investment. Muslims must rediscover the
        prophetic way of conducting business, transparent, productive, and
        grounded in service to the community. The rise of digital and
        decentralized currencies like Bitcoin has renewed discussions on sound
        money that resists manipulation and inflation. Such technologies can
        offer tools for Muslims to rebuild economic independence, ßbut only if
        guided by Shariah principles and ethical intent.
        <br />
        Above all, we must remember that the prohibition of Riba is not merely
        about financial mechanics; it is a test of faith. Do we truly believe
        that Allah’s way brings success, or do we trust man-made systems more?
        The revival of the Muslim world will not come from borrowing or printing
        money it will come from returning to sincerity, hard work, and trust in
        Allah’s promise. Every believer has a role to play, starting from
        purifying their personal finances, avoiding interest, supporting ethical
        businesses, and spreading awareness.
        <br />
        The Prophet Muhammad (peace be upon him) said:
        <br />
        “When you enter into the inah transaction, hold the tails of oxen, are
        pleased with agriculture, and give up conducting jihad (struggle in the
        way of Allah). Allah will make disgrace prevail over you, and will not
        withdraw it until you return to your original religion.”
        <a href="https://sunnah.com/abudawud:3462" target="blank">
          (Abu Dawood, 3462)
        </a>{" "}
        <br />
        This humiliation today is seen in the economic subjugation of Muslim
        lands which are bound by Riba, trapped in debt, and reliant on foreign
        systems. The only escape is to return to the way of Islam, where wealth
        is a means of service, not domination.
        <br />
        <br />
        <br />
        <b>Summary of Today’s Lesson</b>
        <br />
        <br />
        Today we discussed how Riba guarantees profit without risk, turning
        wealth into a tool of oppression where the poor bear the burden while
        the wealthy continue to profit. Islam, by contrast, encourages fairness,
        risk-sharing, and mutual benefit in all economic interactions. Divine
        warnings from the Qur'an make it clear that indulging in Riba is not
        only a sin but a declaration of war from Allah and His Messenger. These
        rulings are further reinforced by prophetic traditions that curse every
        party involved in an interest-based deal. Beyond the legal ruling, we
        reflected on the profound wisdom behind the prohibition. Riba corrodes
        compassion, promotes greed, and leads to structural inequality. Islam
        provides ethical and practical alternatives such as partnership-based
        models and charitable lending. Even when divine commands seem difficult
        to implement in modern settings, a true believer submits out of trust
        and conviction in Allah's knowledge and justice. Ultimately, today’s
        lesson reminded us that Islam is not just a set of rules, but a complete
        way of life rooted in divine mercy and designed to elevate both
        individuals and societies. <br />
        <br />
        <b>Coming up next</b>
        <br />
        <br />
        As we move forward, we’ll explore two of the most commonly misunderstood
        forms of Riba:
        <ul>
          <li>
            Riba al-Fadl, which occurs in everyday barter and trade when unequal
            quantities or qualities of the same goods are exchanged.
          </li>
          <li>
            {" "}
            Riba an-Nasee’ah, which emerges in credit and deferred payments
            where time is monetized through interest.
          </li>
        </ul>
      </p>
      <h2>Test your understanding</h2>
      {questions.map((q, index) => (
        <Question
          key={index}
          questionText={q.text}
          options={q.options}
          correctAnswer={q.correct}
          onAnswer={(value) => handleAnswerChange(index, value)} // pass parent handler
        />
      ))}

      <div style={{ marginTop: "20px", fontWeight: "bold", fontSize: "1.2em" }}>
        Score: {score} / {questions.length}
      </div>

      
       <FloatingPageNav 
              prevLink={links.prev} 
              indexLink={links.index} 
              nextLink={links.next} 
            />
    </div>
  );
}

export default IslamicTradePage6;
